export const GET_RECIPES = "GET_RECIPES";
export const GET_DIETS = "GET_DIETS";
export const FILTER_PER_DIETS = "FILTER_PER_DIETS";
export const ORDER_BY_NAME = "ORDER_BY_NAME";
export const ORDER_BY_SCORE = "ORDER_BY_SCORE";
export const GET_RECIPES_BY_NAME = "GET_RECIPES_BY_NAME";
export const GET_RECIPE_DETAIL = "GET_RECIPE_DETAIL";
export const GET_RECIPE_BY_NAME_TWO = "GET_RECIPE_BY_NAME_TWO";
export const POST_RECIPE = "POST_RECIPE";
export const DELETE_DETAIL = "DELETE_DETAIL";
export const DELETE_DB_RECIPE = "DELETE_DB_RECIPE";
export const UPDATE_DB_RECIPE = "UPDATE_DB_RECIPE";